
export default {
	0: (state) => state,
	1: (state) => ({ ...state, reports: { ...state.reports, editing: state.reports.loaded, loaded: []  } }),
	2: (state) => ({
		...state,
		notification: {
			notif: 1337,
			error: [],
			info: [],
		},
		lut: {
			...state.lut,
			executionLevels: {},
		},
		locale: {
			...state.locale,
			language: locale.available.find(l => l.id === state.locale.language)
		}
	})
}